import { Illustration, Text } from "@clipboard-health/ui-components";
import { Stack } from "@mui/material";
import { Button } from "@src/appV2/redesign/components/Button";

import { CallPurposeSection } from "./CallPurposeSection";
import { RecruiterScreeningWarningCallout } from "./RecruiterScreeningWarningCallout";

const MODAL_STACK_SPACING = 4;

interface SuccessStepContentProps {
  onBrowseMoreJobs: () => void;
  isScreenFirst: boolean;
}

export function SuccessStepContent(props: SuccessStepContentProps) {
  const { onBrowseMoreJobs, isScreenFirst } = props;

  return (
    <Stack spacing={MODAL_STACK_SPACING} alignItems="center" justifyContent="center">
      <Stack spacing={6} alignItems="center" justifyContent="center">
        <Illustration type="phone" />

        <Text variant="h2" textAlign="center">
          Speak to you within 15 minutes!
        </Text>
      </Stack>

      <CallPurposeSection />

      {!isScreenFirst && (
        <Stack justifyContent="flex-end" alignItems="center" paddingTop={10}>
          <RecruiterScreeningWarningCallout />
        </Stack>
      )}

      <Stack spacing={4} sx={{ width: "100%" }}>
        <Button fullWidth variant="contained" size="large" onClick={onBrowseMoreJobs}>
          Browse more jobs
        </Button>
      </Stack>
    </Stack>
  );
}
